module.exports = __webpack_public_path__ + "img/420.d3f8e337.jpg";